import React, { Fragment, PureComponent } from 'react';
import { Tooltip as Tippy } from 'react-tippy';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

import 'react-tippy/dist/tippy.css';
import './tooltip.pcss';


function isTextOverflow(element) {
  return element.scrollWidth > element.clientWidth ||
    element.scrollHeight > element.clientHeight;
}

export default class Tooltip extends PureComponent {
  static propTypes = {
    children: PropTypes.element.isRequired,
    distance: PropTypes.number,
    tip: PropTypes.string,
    position: PropTypes.string,
    arrow: PropTypes.bool,
    arrowSize: PropTypes.string,
    className: PropTypes.string,
    ckeckOverflow: PropTypes.bool,
    touchHold: PropTypes.bool,
  };

  static defaultProps = {
    ckeckOverflow: false,
    distance: 20,
    position: 'top',
    arrow: true,
    arrowSize: 'regular',
    tip: '',
    className: '',
    touchHold: true,
  };

  state = {
    overflow: false,
  };

  componentDidMount() {
    this.checkOverflow();
  }

  componentDidUpdate(prevProps) {
    if (this.props.tip !== prevProps.tip) {
      this.checkOverflow();
    }
  }

  checkOverflow = () => {
    if (!this.props.ckeckOverflow) return;
    const element = ReactDOM.findDOMNode(this);
    const overflow = isTextOverflow(element);
    if (overflow !== this.state.overflow) {
      this.setState({ overflow });
    }
  };

  renderTitle = () => (
    <div className={this.props.className}>{this.props.tip}</div>
  );

  render() {
    const { children, position, arrow, arrowSize, distance, ckeckOverflow, touchHold } = this.props;
    const { overflow } = this.state;
    if (!overflow && ckeckOverflow) {
      return (
        <Fragment>{children}</Fragment>
      );
    }

    return (
      <Tippy
        distance={distance}
        html={this.renderTitle()}
        delay={500}
        hideDelay={0}
        duration={0}
        position={position}
        arrow={arrow}
        arrowSize={arrowSize}
        touchHold={touchHold}
        {...this.props}
      >
        {children}
      </Tippy>
    );
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/Tooltip/index.js